/**
 * InsideSwitch — Layout version router.
 *
 * Reads VITE_LAYOUT env variable at build time:
 *   v1 (default) → old multi-sidebar layout (InsideModuleSidebar + InsideFeatureSidebar)
 *   v2            → new single-sidebar layout (InsideSingleSidebar)
 *
 * How to run each layout:
 *   pnpm dev              → V1 (old layout, default)
 *   pnpm dev:v2           → V2 (new layout, local)
 *   pnpm dev:staging      → V1 staging
 *   pnpm dev:staging:v2   → V2 staging
 *
 * When new layout is complete & approved:
 *   1. Set VITE_LAYOUT=v2 in .env as default
 *   2. Delete src/layout/Inside.jsx (old v1)
 *   3. Move src/layout/v2/Inside.jsx → src/layout/Inside.jsx
 *   4. Remove this file (InsideSwitch.jsx)
 *   5. Update RequireAuth.jsx import back to '@layout/Inside'
 */

import React, { lazy, Suspense } from 'react';

const IS_V2 = import.meta.env.VITE_LAYOUT === 'v2';

// Lazy load both layouts — only the active one is bundled when tree-shaking is applied.
const InsideV1 = lazy(() => import('./Inside'));
const InsideV2 = lazy(() => import('./v2/Inside'));

/**
 * InsideSwitch wraps the active layout.
 * Suspense fallback is null — the parent (RequireAuth) already handles loading states.
 */
const InsideSwitch = ({ children }) => {
    const Layout = IS_V2 ? InsideV2 : InsideV1;
    return (
        <Suspense fallback={null}>
            <Layout>{children}</Layout>
        </Suspense>
    );
};

export default InsideSwitch;
